import { useEffect } from 'react';
import { trackWebVitals } from '../configs/analytics';

export const useWebVitals = () => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            trackWebVitals();
        }
    }, []);
};